import type {
  DeviceCalendarOption,
  DeviceCalendarPermissionState,
  ExternalDeviceCalendarEvent,
} from './deviceCalendarsTypes';

// Web ve CalendarNext modülünü taşımayan eski ikililer için güvenli varsayılan.
// Mobil build Metro'da deviceCalendars.native.ts dosyasını kullanır.
export const deviceCalendarsAvailable = false;

export async function getDeviceCalendarPermissionState(): Promise<DeviceCalendarPermissionState> {
  return 'unavailable';
}

export async function requestDeviceCalendarPermission(): Promise<DeviceCalendarPermissionState> {
  return 'unavailable';
}

export async function listDeviceCalendars(): Promise<DeviceCalendarOption[]> {
  return [];
}

export async function listSelectedDeviceCalendarEvents(
  _calendarIds: string[],
  _calendars: DeviceCalendarOption[],
  _startDate: Date,
  _endDate: Date
): Promise<ExternalDeviceCalendarEvent[]> {
  return [];
}
